// Function to handle resizing
function resizeHandler() {
    console.log("window resized");

    if (window.innerWidth < 750) {
        document.querySelectorAll('.footer-collapse-content').forEach((content) => {
            content.style.height = '0'; // Collapse by default
            content.style.overflow = 'hidden'; // Prevent content from overflowing
            content.style.transition = 'height 0.3s ease'; // Add smooth transition
            content.classList.remove('expanded'); // Ensure no residual expanded state
        });
        document.querySelectorAll('.footer-nav-header').forEach((header) => {
            header.classList.remove('expanded'); // Reset header state
        });
    } else {
        document.querySelectorAll('.footer-collapse-content').forEach((content) => {
            content.style.height = 'auto'; // Fully expand on desktop
            content.style.overflow = 'visible'; // Remove overflow restriction
            content.classList.add('expanded'); // Ensure all content is expanded
        });
        document.querySelectorAll('.footer-nav-header').forEach((header) => {
            header.classList.add('expanded'); // Add expanded state to headers
        });
    }
}

// Initial call on page load
resizeHandler();

// Attach the resize handler to the window resize event
window.addEventListener('resize', resizeHandler);

// Event listener for footer nav headers
document.querySelectorAll('.footer-nav-header').forEach((header) => {
    header.addEventListener('click', () => {
        if (window.innerWidth < 767) {
            const content = header.nextElementSibling; // Get the sibling .footer-collapse-content
            
            if (content && content.classList.contains('footer-collapse-content')) {
                if (!content.classList.contains('expanded')) {
                    // Open: Calculate full height and set it
                    const fullHeight = content.scrollHeight + 'px'; // Full height of content
                    content.style.height = fullHeight;
                    content.classList.add('expanded'); // Add expanded class to content
                    header.classList.add('expanded'); // Add expanded class to header
                } else {
                    // Close: Set height to 0
                    content.style.height = '0';
                    content.classList.remove('expanded'); // Remove expanded class from content
                    header.classList.remove('expanded'); // Remove expanded class from header
                }
            }
        }
    });
});
